// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tether-element .multiEmail_MHr92, .tether-element .multiSms_SulM3 {
  display: none;
}

.multiEmail_MHr92.multiError_pMD5Z, .multiSms_SulM3.multiError_pMD5Z {
  border-color: var( --color-Error500, red );
}

.shareTempUserBody_weVaV {
  width: 496px;
}

.tab_AIORF {
  min-height: 496px;
}

.footer_THwZG {
  padding: var(--size-padLarge, 16px);
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/api-ui-user-management/lib/temporaryUser/components/ShareTemporaryUserAccess.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":[":global( .tether-element ) .multiEmail, :global( .tether-element ) .multiSms {\n  display: none;\n}\n\n.multiEmail.multiError, .multiSms.multiError {\n  border-color: var( --color-Error500, red );\n}\n\n.shareTempUserBody {\n  width: 496px;\n}\n\n.tab {\n  min-height: 496px;\n}\n\n.footer {\n  padding: var(--size-padLarge, 16px);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"multiEmail": `multiEmail_MHr92`,
	"multiSms": `multiSms_SulM3`,
	"multiError": `multiError_pMD5Z`,
	"shareTempUserBody": `shareTempUserBody_weVaV`,
	"tab": `tab_AIORF`,
	"footer": `footer_THwZG`
};
export default ___CSS_LOADER_EXPORT___;
